export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What type of server fits in a metal framework?",
    "description": "Rack server."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "What does a cable management arm do?",
    "description": "Cable management arms are used to keep the cables organized while sliding the server out of the rack for maintenance."
  },
  {
    "id": 3,
    "topic_id": 1,
    "title": "How many inches is a U?",
    "description": "1.75 inches."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "What type of server requires a converter to be placed in a rack?",
    "description": "Tower server."
  },
  {
    "id": 5,
    "topic_id": 2,
    "title": "What term describes the size, appearance, or dimensions of a server?",
    "description": "Form factor."
  },
  {
    "id": 6,
    "topic_id": 2,
    "title": "What rack component allows for the server to be serviced without removing it from the rack?",
    "description": "Rail kit."
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "What interface is an alternative to the BIOS interface in modern computers?",
    "description": "UEFI."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "What technology includes as one of its configurations striping with parity?",
    "description": "RAID."
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "What type of RAID does <i>not</i> provide fault tolerance?",
    "description": "RAID 0."
  },
  {
    "id": 10,
    "topic_id": 2,
    "title": "What is the minimum number of drives required for RAID 1?",
    "description": "2."
  },
  {
    "id": 11,
    "topic_id": 2,
    "title": "What type of RAID allows you to use 100% of the drive space for data?",
    "description": "RAID 0."
  },
  {
    "id": 12,
    "topic_id": 2,
    "title": "Which has better performance, software or hardware RAID?",
    "description": "hardware RAID."
  },
  {
    "id": 13,
    "topic_id": 2,
    "title": "Where is firmware stored in a server?",
    "description": "Flash ROM."
  },
  {
    "id": 14,
    "topic_id": 2,
    "title": "What form of storage requires a storage-special switch?",
    "description": "SAN."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "What operating system uses the ext4 filesystem?",
    "description": "Linux."
  },
  {
    "id": 16,
    "topic_id": 3,
    "title": "Windows NT introduced which filesystem?",
    "description": "NTFS."
  },
  {
    "id": 17,
    "topic_id": 3,
    "title": "What filesystem was developed by Sun Microsystems?",
    "description": "ZFS."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "What type of server role authenticates users to the network?",
    "description": "Directory services."
  },
  {
    "id": 19,
    "topic_id": 3,
    "title": "What type of data access is provided by SAN?",
    "description": "Block level."
  },
  {
    "id": 20,
    "topic_id": 3,
    "title": "Which storage network type is less expensive , SAN or NAS?",
    "description": "NAS."
  },
  {
    "id": 21,
    "topic_id": 3,
    "title": "What is the name of the Active Directory database file?",
    "description": "ntds.dit."
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "When planning for the Active Directory database, how much additional space should you have above the size of the ntds.dit file?",
    "description": "Additional space equal to 20% of the size of the ntds.dit file."
  },
  {
    "id": 23,
    "topic_id": 4,
    "title": "What is a snapshot of the performance of key resources in the server such as the CPU, memory, disk, and network card called?",
    "description": "Baseline."
  },
  {
    "id": 24,
    "topic_id": 1,
    "title": "Which storage solution requires a high-speed network separate from the LAN?",
    "description": "Storage area network (SAN)."
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "What protocol is used in a SAN?",
    "description": "Fibre Channel."
  },
  {
    "id": 26,
    "topic_id": 3,
    "title": "What must be installed in a server to connect to a SAN?",
    "description": "Host bus adapter (HBA)."
  },
  {
    "id": 27,
    "topic_id": 2,
    "title": "What components are identified by WWNs?",
    "description": "Host bus adapters (HBAs)."
  },
  {
    "id": 28,
    "topic_id": 3,
    "title": "What backup method backs up all files that have been changed since the last full backup?",
    "description": "Differential."
  },
  {
    "id": 29,
    "topic_id": 3,
    "title": "In which Windows tool can you disable USB ports?",
    "description": "Device Manager."
  },
  {
    "id": 30,
    "topic_id": 3,
    "title": "What value identifies the host and the location of the hostname in the DNS namespace of the organization?",
    "description": "Fully qualified domain name (FQDN)."
  },
  {
    "id": 31,
    "topic_id": 3,
    "title": "What type of backup backs up all files that have been changed since the last full or incremental backup?",
    "description": "Incremental."
  },
  {
    "id": 32,
    "topic_id": 3,
    "title": "What technology encapsulates SCSI commands in IP packets?",
    "description": "iSCSI."
  },
  {
    "id": 33,
    "topic_id": 4,
    "title": "Which type of storage network provides block-level access to the data?",
    "description": "Storage area network (SAN)."
  },
  {
    "id": 34,
    "topic_id": 4,
    "title": "What technology encapsulates Fibre Channel frames in Ethernet frames?",
    "description": "Fibre Channel over Ethernet ( FCoE)."
  },
  {
    "id": 35,
    "topic_id": 4,
    "title": "What is the minimum number of drives required for RAID 10?",
    "description": "4."
  },
  {
    "id": 36,
    "topic_id": 2,
    "title": "What RAID variant is composed of a striped set that is mirrored?",
    "description": "RAID 10."
  },
  {
    "id": 37,
    "topic_id": 4,
    "title": "Where are update files stored on a Windows Server 2012 R2 server?",
    "description": "windows\\winsxs."
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "What command is used to manage event logs in Windows Server 2022?",
    "description": "wevtutil."
  },
  {
    "id": 39,
    "topic_id": 2,
    "title": "What technology includes an examination of the state of the computer the user is introducing to the network when making a remote access or VPN connection to the network?",
    "description": "Network access control (NAC)."
  },
  {
    "id": 40,
    "topic_id": 2,
    "title": "What is a firewall with two NICs called?",
    "description": "Dual-homed."
  },
  {
    "id": 41,
    "topic_id": 1,
    "title": "What security function can prevent unauthorized users from connecting to any open network outlet?",
    "description": "Port security."
  },
  {
    "id": 42,
    "topic_id": 1,
    "title": "What security standard is sometimes called port-based security?",
    "description": "802.1x."
  },
  {
    "id": 43,
    "topic_id": 1,
    "title": "What type of firewall reads the individual commands of the protocols that are being served?",
    "description": "Application-level proxy."
  },
  {
    "id": 44,
    "topic_id": 1,
    "title": "What is the amount of time a UPS can provide power at a given level called?",
    "description": "Runtime."
  },
  {
    "id": 45,
    "topic_id": 1,
    "title": "What Windows backup program can back up open files?",
    "description": "Windows Volume Shadow Copy Service (VSS)."
  },
  {
    "id": 46,
    "topic_id": 1,
    "title": "In a biometric authentication system, what is it called when a user should not be permitted access and is permitted access?",
    "description": "False positive."
  },
  {
    "id": 47,
    "topic_id": 1,
    "title": "What is the IPv6 loopback address?",
    "description": "::1."
  },
  {
    "id": 48,
    "topic_id": 1,
    "title": "What type of firewall uses a table that tracks every communications channel?",
    "description": "Stateful firewall."
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "What operating system uses the iptables firewall?",
    "description": "Linux."
  },
  {
    "id": 50,
    "topic_id": 1,
    "title": "What is the second stage in the asset life cycle?",
    "description": "Usage."
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "What Layer 2 addresses does port security use in its operation?",
    "description": "MAC addresses."
  },
  {
    "id": 52,
    "topic_id": 2,
    "title": "Which security standard is sometimes called port-based security?",
    "description": "802.1x."
  },
  {
    "id": 53,
    "topic_id": 2,
    "title": "What type of IPv6 address has a prefix of FE80::?",
    "description": "Link local."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "What type of backup is taken from one device and restored to another device?",
    "description": "Side by side."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "What technology generated the IP address 169.254.6.6?",
    "description": "Automatic Private IP Addressing (APIPA)."
  },
  {
    "id": 56,
    "topic_id": 1,
    "title": "Which hypervisor type runs directly on the host\u2019s hardware to control the hardware and to manage guest operating systems?",
    "description": "Type I or bare metal."
  },
  {
    "id": 57,
    "topic_id": 1,
    "title": "Which type of snapshot is taken every time a user enters data or changes data and only includes the changed data?",
    "description": "Copy-on-write."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "What type of backup is one in which the entire system, including operating system, applications, configuration data, and files, are saved?",
    "description": "Bare metal."
  },
  {
    "id": 59,
    "topic_id": 3,
    "title": "List one advantage of iSCSI.",
    "description": "Possible answers:."
  },
  {
    "id": 60,
    "topic_id": 1,
    "title": "<li>What backup medium historically can provide only sequential access?</li>",
    "description": "Tape."
  },
  {
    "id": 61,
    "topic_id": 1,
    "title": "In what tape rotation scheme are three sets of backups defined as daily, weekly, and monthly?",
    "description": "Grandfather/father/son (GFS)."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "In what type of storage are the drives attached to the server locally through a SATA, USB, SCSI, or Serial Attached SCSI (SAS) connection?",
    "description": "Direct attached storage (DAS)."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "What is the unseating of components due to a cycle of overheating and cooling inside the system called?",
    "description": "Chip creep."
  },
  {
    "id": 64,
    "topic_id": 3,
    "title": "What is the proper humidity level for the server room?",
    "description": "30 to 50 percent."
  },
  {
    "id": 65,
    "topic_id": 3,
    "title": "The tag on an RFID device that transmits its presence wirelessly is called what?",
    "description": "Transponder."
  },
  {
    "id": 66,
    "topic_id": 3,
    "title": "What is the final step in the CompTIA troubleshooting model?",
    "description": "Document findings, actions, and outcomes."
  },
  {
    "id": 67,
    "topic_id": 3,
    "title": "What form of phishing targets CEOs?",
    "description": "Whaling."
  },
  {
    "id": 68,
    "topic_id": 3,
    "title": "At what point in the startup do beep codes sound?",
    "description": "POST."
  },
  {
    "id": 69,
    "topic_id": 4,
    "title": "Computer fans work by ___________________ air through the computer.",
    "description": "Pulling."
  },
  {
    "id": 70,
    "topic_id": 2,
    "title": "What is the primary benefit of DDR3 over DDR2 ?",
    "description": "DDR3 transfers data at twice the rate of DDR2."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "What component is failing when you hear the click of death?",
    "description": "Hard drive."
  },
  {
    "id": 72,
    "topic_id": 2,
    "title": "What is a kernel panic?",
    "description": "An action taken by system\u2019s kernel upon detecting an internal error in which either it is unable to safely recover or continuing to run the system would have a higher risk of major data loss."
  },
  {
    "id": 73,
    "topic_id": 2,
    "title": "What type of IPV6 address is self-generated by every interface enabled for IPv6?",
    "description": "Link local."
  },
  {
    "id": 74,
    "topic_id": 2,
    "title": "Which IP configuration component makes accessing remote networks possible?",
    "description": "Default gateway address."
  },
  {
    "id": 75,
    "topic_id": 2,
    "title": "What command is used to view the IP address\u2013to\u2013MAC address mappings on a Windows device?",
    "description": "arp -a."
  },
  {
    "id": 76,
    "topic_id": 200,
    "title": "Differentiate the server form factors.",
    "description": "These include tower servers; 1U, 2U, 3U, and 4U rack-mounted servers; and blade servers. The U in the rack server notation indicates the number of units in the rack that the servers use."
  },
  {
    "id": 77,
    "topic_id": 200,
    "title": "Describe the components found inside the server.",
    "description": "Inside the server case you will find all of the same components you might find in a workstation, but they will be more robust and there may be more of them. These include CPU, memory, NICs, hard drives, riser cards, and RAID controllers."
  },
  {
    "id": 78,
    "topic_id": 200,
    "title": "Understand the power requirements of servers.",
    "description": "Servers can require from 350 W (for a 1U rack mount) to 4500 W for a chassis with 14 blades in it."
  },
  {
    "id": 79,
    "topic_id": 200,
    "title": "Identify and mitigate cooling issues.",
    "description": "Explain how to use heatsinks, fans, and baffles inside the case to eliminate the heat created by servers. In the server room or datacenter, understand how to deploy baffles and hot/cold aisles to remove heat from the room."
  },
  {
    "id": 80,
    "topic_id": 200,
    "title": "Install and configure a server operating system.",
    "description": "Describe the steps in the process and identify which are required and which are optional. Understand the importance of creating a performance baseline."
  },
  {
    "id": 81,
    "topic_id": 200,
    "title": "Identify the components of virtualization and describe their roles.",
    "description": "These components include but are not limited to the host and guest, the management interface, and the hypervisor. You should also be able to describe how CPU, memory, and other resources are shared by the VMs."
  },
  {
    "id": 82,
    "topic_id": 200,
    "title": "Perform proper server maintenance.",
    "description": "Identify the procedures involved in updating drivers and firmware. Describe how SLAs are used to control the delivery of service to the network."
  },
  {
    "id": 83,
    "topic_id": 200,
    "title": "Describe speeds of magnetic hard drives.",
    "description": "These include 5400 RPM, 7200 RPM, 10000 RPM, and 15000 RPM. Understand how the speed impacts the latency and data rates."
  },
  {
    "id": 84,
    "topic_id": 200,
    "title": "Identify examples of hot-swappable hardware.",
    "description": "These include drives, cages, expansion cards, power supplies, and fans."
  },
  {
    "id": 85,
    "topic_id": 200,
    "title": "Identify licensing models.",
    "description": "These include but are not limited to per-instance, per-concurrent user, per-server, per-socket, per-core, site-based, physical vs. virtual, and node-locked."
  },
  {
    "id": 86,
    "topic_id": 200,
    "title": "Describe speeds of magnetic hard drives.",
    "description": "These include 5400 RPM, 7200 RPM, 10,000 RPM and 15,000 RPM. Understand how the speed impacts the latency and data rates."
  },
  {
    "id": 87,
    "topic_id": 200,
    "title": "Explain the importance of asset management and documentation.",
    "description": "List what should be included when creating an asset inventory. Understand the importance of organizing and maintaining documentation. Describe some of the types of sensitive documents that require special treatment."
  },
  {
    "id": 88,
    "topic_id": 200,
    "title": "Describe clustering deployment options.",
    "description": "Clustering deployment options include active\u2013active and active\u2013passive setups. You also need to know about failover and failback and the function of the cluster heartbeat."
  },
  {
    "id": 89,
    "topic_id": 200,
    "title": "Explain the approaches to load balancing.",
    "description": "Be able to describe the difference between software and hardware load balancing. Also be able to explain the operation of the most recently used (MRU) and round robin allocation methods."
  },
  {
    "id": 90,
    "topic_id": 200,
    "title": "Compare and contrast physical security methods and concepts.",
    "description": "Among these methods are multifactor authentication, mantraps, RFID chips, and access lists. You should also be familiar with all types of locks, including server, rack, and cabinet locks."
  },
  {
    "id": 91,
    "topic_id": 200,
    "title": "Describe what hardening the server entails.",
    "description": "Explain the value of stopping unneeded services, closing unneeded ports, installing only required software, and installing the latest operating system patches. You should also know about physical hardening, including disabling unneeded hardware and physical ports, implementing a BIOS password, and using chassis locks."
  },
  {
    "id": 92,
    "topic_id": 200,
    "title": "List proper environment controls and techniques.",
    "description": "Identify the steps required to ensure availability of the resources on the servers. These include implementing UPS systems, using redundant rack PDUs, and provisioning multiple circuits. It also entails monitoring the temperature and humidity to ensure they are at the recommended levels. Finally, the layout of the server room should be such that it promotes airflow that removes heat."
  },
  {
    "id": 93,
    "topic_id": 200,
    "title": "Describe logical access control methods.",
    "description": "Explain the proper use of access control lists (ACLs) to protect resources. Use groups to apply role-based access control. List common permissions and identify the tasks they enable when working with resources."
  },
  {
    "id": 94,
    "topic_id": 200,
    "title": "Implement secure storage methods and secure data disposal techniques.",
    "description": "Describe various levels at which encryption can be applied and the implications of each. List the techniques for removing sensitive data from storage devices. Understand the advantages and disadvantages of each method."
  },
  {
    "id": 95,
    "topic_id": 200,
    "title": "Identify the most common and important network settings.",
    "description": "A server usually requires an IP address, a subnet mask, a default gateway, and the address of a DNS server to function on a network. Also understand the purpose of private IP addressing and the function of APIPA."
  },
  {
    "id": 96,
    "topic_id": 200,
    "title": "Compare and contrast protocols and ports numbers.",
    "description": "List the port numbers used by well-known network protocols and services, including but not restricted to, FTP, SNMP, DNS, SMTP, HTTP, and SSH. Describe the functionality provided by each."
  },
  {
    "id": 97,
    "topic_id": 200,
    "title": "Differentiate backup site types",
    "description": "Describe the pros and cons of various alternate site types, such as hot, warm, and cold sites. Differentiate replication methodologies, including constant, background, synchronous, asynchronous, and file locking."
  },
  {
    "id": 98,
    "topic_id": 200,
    "title": "Implement appropriate backup techniques",
    "description": "Differentiate backup methodologies, including but not limited to full, incremental, and differential backups. Describe the access techniques of various backup media such as tape and optical media. Identify best practices for media storage and labeling. Discuss the security and environmental considerations of storing media off-site and on-site."
  },
  {
    "id": 99,
    "topic_id": 200,
    "title": "List the eight steps in the CompTIA troubleshooting method.",
    "description": "In order, the steps are identify the problem and determine the scope; establish a theory of probable cause; test the theory to determine cause; establish a plan of action to resolve the problem and notify impacted users; implement the solution or escalate as appropriate; verify full system functionality and, if applicable, implement preventive measures; perform a root cause analysis; and document findings, actions, and outcomes throughout the process."
  },
  {
    "id": 100,
    "topic_id": 200,
    "title": "Identify common hardware issues, their causes, and solutions.",
    "description": "Describe common hardware issues, among them failed POST, overheating, memory failure, onboard component failure, processor failure, incorrect boot sequence, expansion card failure, operating system not found, drive failure, power supply failure, and I/O failure."
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Identify common software issues, their causes, and their solutions.",
    "description": "Describe common software issues, among them: user unable to logon, user cannot access resources, memory leak, BSOD/stop, OS boot failure, driver issues, runaway process, cannot mount drive, cannot write to system log, slow OS performance, patch update failure, service failure, hangs on shutdown, and user cannot print."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "Identify common connectivity issues.",
    "description": "This includes Internet connectivity failures, email failures, a misconfigured DHCP server, destination host unreachable messages, unknown host messages, a misconfigured default gateway, failure of the service provider, and inability to reach a host by name/FQDN."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Identify common causes of connectivity issues.",
    "description": "Describe common causes such as improper IP configuration, VLAN configuration, port security, improper subnetting, component failure, incorrect OS route tables, bad cables, firewall misconfiguration hardware failure, software failure, misconfigured NICs, routing/switch issues, DNS and/or DHCP failure, misconfigured Hosts file, and IPv4 vs. IPv6 misconfigurations."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "List common command-line tools.",
    "description": "Tools include ping, tracert/traceroute, ipconfig/ifconfig, nslookup, net use/mount, route, nbtstat, and netstat."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Identify common security issues.",
    "description": "These include file integrity issues, privilege escalation, applications that will not load, inability to access network file/shares, inability to open files, excessive access, and excessive memory utilization."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Identify common causes of security issues.",
    "description": "Causes include open ports, active services, inactive services, intrusion detection configurations, anti-malware configurations, local/Group Policies, firewall rules, misconfigured permissions, virus infections, and rogue processes/services."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "List common tools.",
    "description": "Among these are port scanners, sniffers, cipher, checksums, Telnet clients, and anti-malware."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Identify common storage issues.",
    "description": "These issues include slow file access, OS not found, data not available, unsuccessful backups, error lights, inability to mount the device, drive not available, cannot access logical drive, data corruption, slow I/O performance, restore failure, cache failure, and multiple drive failure."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Describe common causes of storage issues.",
    "description": "Describe common causes of storage problems, such as media failures, drive failures, controller failures, HBA failures, loose connectors, cable problems, misconfiguration, improper termination, corrupted boot sector, corrupted filesystem table, array rebuild, improper disk partition, bad sectors, cache battery failure, cache turned off, insufficient space, improper RAID configuration, mismatched drives, and backplane failure."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "List common tools.",
    "description": "Understand the use of tools such as partitioning tools, disk management, RAID array management software, array management software, system logs, net use/mount commands, and monitoring tools."
  }
];
